<template>
  <app-layout>
    <div class="flex items-start max-w-7xl mx-auto py-10 space-x-4">
      <div class="w-1/2 flex flex-wrap">
        <update-profile-information-form v-if="$page.props.jetstream.canUpdateProfileInformation"
                                         :user="$page.props.user" class="w-full"/>

        <update-password-form v-if="$page.props.jetstream.canUpdatePassword" class="mt-4 w-full"/>
      </div>

      <div class="w-1/2">
        <div class="px-4 py-5 bg-white sm:p-6 shadow sm:rounded-md">
          <h3 class="font-bastia">Mes factures</h3>
          <hr class="w-24 border-dark-blue mt-3 mb-6">
          <div class="mt-4 w-full grid grid-cols-2 gap-4">
            <invoice-loading-card v-if="paymentsLoading" :loading="true"></invoice-loading-card>
            <invoice-loading-card v-if="paymentsLoading" :loading="true"></invoice-loading-card>
            <template v-for="submission in payments">
              <template v-for="payment in submission.payments">
                <div class="border-medium-blue rounded">
                  <invoice-card :payment="payment" v-if="!paymentsLoading"></invoice-card>
                </div>
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import DeleteUserForm from './DeleteUserForm'
import JetSectionBorder from '@/Jetstream/SectionBorder'
import LogoutOtherBrowserSessionsForm from './LogoutOtherBrowserSessionsForm'
import TwoFactorAuthenticationForm from './TwoFactorAuthenticationForm'
import UpdatePasswordForm from './UpdatePasswordForm'
import UpdateProfileInformationForm from './UpdateProfileInformationForm'
import InvoiceLoadingCard from "@/Components/InvoiceLoadingCard";
import InvoiceCard from "@/Components/InvoiceCard";

export default {
  components: {
    AppLayout,
    DeleteUserForm,
    UpdatePasswordForm,
    UpdateProfileInformationForm,
    InvoiceLoadingCard,
    InvoiceCard,
  },

  data() {
    return {
      payments: [],
      paymentsLoading: true,
    }
  },

  mounted() {
    this.getPayments();
  },

  methods: {
    getPayments() {
      axios.get(route('user.payments'))
          .then((response) => {
            this.payments = response.data
            this.paymentsLoading = false
          })
          .catch((error) => {
            console.log(error)
          })
    }
  }
}
</script>
